import React, { PropsWithChildren } from 'react';

type Props = {
  className?: string;
  labelClass?: string;
  label?: string;
  name?: string;
  value?: string;
  onChange?: React.ChangeEventHandler<HTMLTextAreaElement>;
  placeholder?: string;
  required?: boolean;
  error?: string | null;
  rows?: number;
};

export const InputTextarea: React.FC<PropsWithChildren<Props>> = ({
  className,
  labelClass,
  label,
  name,
  value,
  onChange,
  placeholder = '',
  required = false,
  error,
  rows = 2,
}) => {
  return (
    <>
      {label && (
        <label
          htmlFor={name}
          className={`cursor-text font-bold ${labelClass || ''}`}>
          {label}
        </label>
      )}
      {/* border-copper/30 placeholder:text-dark/40 ring-copper focus:ring-dark dark:focus:ring-copper dark:text-ivory mt-1 w-full rounded-md border bg-white px-3 py-1.5 text-lg outline-none focus:ring-2 null  */}
      <textarea
        className={`border-copper/30 ring-copper focus:ring-dark dark:focus:ring-copper dark:text-ivory placeholder:text-dark/40 relative mt-1 w-full resize-none appearance-none rounded-md border bg-white px-3 py-1.5 text-lg shadow-none outline-none focus:ring-2 focus:outline-none dark:bg-white/5 dark:placeholder:text-white/40 ${error && 'border-2 border-red-500 dark:border-red-500'} ${
          className || ''
        }`}
        name={name}
        value={value}
        onChange={onChange}
        required={required}
        placeholder={placeholder}
        rows={rows}
      />
      {error && (
        <p className="mt-1 text-sm text-red-600 dark:text-red-400">{error}</p>
      )}
    </>
  );
};
